<template>
  <div class="path-container">
    <svg :width="svgWidth" :height="svgHeight">
      <path
        :d="path"
        stroke="rgb(118, 118, 118)"
        stroke-linejoin="round"
        stroke-width="1"
        fill="none"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    multiline: Boolean,
    startElementId: String,
    endElementId: String,
    refreshKey: Number,
    start: {
      type: String,
      default: 'right'
    },
    end: {
      type: String,
      default: 'left'
    },
    startXOffset: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      startPos: { x: 0, y: 0 },
      endPos: { x: 0, y: 0 },
      svgWidth: 0,
      svgHeight: 0,
      path: ''
    }
  },
  mounted () {
    this.updatePath()
    window.addEventListener('resize', this.updatePath, { passive: true })
    this.$nextTick(() => {
      this.updatePath()
    })
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.updatePath)
  },
  methods: {
    updatePath () {
      const coordinates = this.getCoordinates()
      if (!coordinates) return

      const { xStart, xEnd, yStart, yEnd } = coordinates

      if (this.end === 'left') {
        // L-shaped path: go down from start, then turn right to end element's left side
        let d = `M${xStart},${yStart} L${xStart},${yEnd}`

        const offset = 7
        const branchX = xEnd - 10

        d += ` L${branchX},${yEnd}`
        d += ` M${branchX},${yEnd} L${xEnd},${yEnd}` // Middle (horizontal) line.
        if (this.multiline) {
          d += ` M${branchX},${yEnd} L${xEnd},${yEnd - offset}` // Top-angled line.
          d += ` M${branchX},${yEnd} L${xEnd},${yEnd + offset}` // Bottom-angled line.
        }

        this.path = d
      } else {
        let d = `M${xStart},${yStart} L${xStart},${yEnd - 10} L${xEnd},${yEnd - 10}`

        const verticalExtension = 3 // Change this to adjust the point where crow feet starts.
        const branchY = yEnd - 10 + verticalExtension
        d += ` L${xEnd},${branchY}`

        const offset = 7 // Change this to adjust the angel of side lines of the crow feet.

        d += ` M${xEnd},${branchY} L${xEnd},${yEnd}` // Middle (vertical) line.
        if (this.multiline) {
          d += ` M${xEnd},${branchY} L${xEnd - offset},${yEnd}` // Left-angled line.
          d += ` M${xEnd},${branchY} L${xEnd + offset},${yEnd}` // Right-angled line.
        }

        this.path = d
      }
    },
    getCoordinates () {
      const startElement = document.getElementById(this.startElementId)
      const endElement = document.getElementById(this.endElementId)

      if (!startElement || !endElement) return

      const startRect = startElement.getBoundingClientRect()
      const endRect = endElement.getBoundingClientRect()

      // Find parent element with classname service-border
      let parentElement = startElement.offsetParent
      while (parentElement && !parentElement.classList.contains('service-border')) {
        parentElement = parentElement.offsetParent
      }

      if (!parentElement) {
        return
      }

      this.svgWidth = parentElement.offsetWidth
      this.svgHeight = parentElement.offsetHeight

      const parentRect = parentElement.getBoundingClientRect()

      if (this.start === 'bottom') {
        const xBase = this.startXOffset
          ? startRect.left - parentRect.left + this.startXOffset
          : startRect.left - parentRect.left + startRect.width / 2
        this.startPos = {
          x: xBase,
          y: startRect.top - parentRect.top + startRect.height
        }
      }

      if (this.end === 'top') {
        this.endPos = {
          x: endRect.left - parentRect.left + endRect.width / 2,
          y: endRect.top - parentRect.top
        }
      }

      if (this.end === 'left') {
        this.endPos = {
          x: endRect.left - parentRect.left,
          y: endRect.top - parentRect.top + endRect.height / 2
        }
      }
      return {
        xStart: this.startPos.x,
        yStart: this.startPos.y,
        xEnd: this.endPos.x,
        yEnd: this.endPos.y
      }
    }
  },
  watch: {
    refreshKey () {
      this.$nextTick(() => {
        this.updatePath()
      })
    }
  }
}
</script>

<style scoped>
.path-container {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: -1;
}
</style>
